<template>
  <section class="industry-info">
    <div
      v-for="(item, index) in list"
      v-show="!item.isHide"
      :key="index"
      class="tr">
      <span>{{ item.label }}</span>
      <span
        v-if="item.isFile">
        <span
          class="blue pointer"
          @click="openFile(item)">{{ item.value }}</span>
      </span>
      <span v-else-if="item.isArray">
        <span
          v-for="(inItem, inIndex) in item.value"
          v-show="inItem.value"
          :key="'in ' + index + inIndex">
          <span class="block">{{ inItem.label }}</span>
        </span>
      </span>
      <span v-else>{{ item.value }}</span>
    </div>
  </section>
</template>
<script>
import MixinOptions from '@/mixins/options'
export default {
  name: 'IndustryInfo',
  mixins: [MixinOptions],
  props: {
    // type: [String, Number],
    form: {
      props: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      list: []
    }
  },
  computed: {
    type() {
      return this.form.insurance_type
    }
  },
  watch: {
    form: {
      immediate: true,
      deep: true,
      handler(val) {
        if(JSON.stringify(val) != '{}') {
          this.getIndustryInfo()
        }
      }
    }
  },
  methods: {
    openFile(data) {
      const { haveFile } = data
      if(haveFile) {
        const { business_file } = this.form
        const { url } = business_file
        window.open(url, '_blank')
      }
    },
    getIndustryInfo() {
      const {
        occ_information_list,
        name, phone, email, promo_code, restaurant_id,
        isrd_nm, business_hour, no_of_seats, floor_area, floor_area_of_seated, floor_area_of_workspace,
        building_structure_ind, designer_ind, claim_history_ind, business_file,
        need_group_personal_ind, need_group_medical_ind, need_money_ind, need_fidelity_ind,
        contents_ind, kind_of_stock, total_stocks, high_stock_ind, high_stock_value,
        public_liability_ind, cook_with_fire, fire_system_ind, burglar_system_ind,
        signboard_outside_ind, high_from_ground_level, size_of_signboard, employee_ind,
        total_no_of_employee,
        // pure
        fire_alarm_ind, burglar_alarm_ind, work_space_ind, insured_premises, stocks_stored_ind,
        manual_work_ind, station_overseas_ind,
        // retail
        glass_premises_ind, value_of_glass, stock_stored_locked_ind, value_stock_stored_locked,
        // beauty
        no_of_rooms, value_of_beauty_devices,
        // education
        typ_of_courses, target_customers_group, regular_classes, no_of_people, class_type,
        // warehouse
        building_type, warehouse_type, space_divided_type, need_marine_ind, max_piece_carton_value,
        avg_stocks_value, max_stocks_value, stocks_stored_type, entrance_exit,
        // medical
        devices_insured_ind, insured_machinery, other_service_provided,
        //
        need_group_travel_ind,
      } = this.form

      let result = []
      if(this.type == 2001) {
        result = [
          {
            label: 'Type of Restaurant',
            value: this.getOptionName('globalOptions.typ_of_restaurant', restaurant_id)
          },
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Business hour',
            value: business_hour
          },
          {
            label: 'No. of seats',
            value: no_of_seats
          },
          {
            label: 'Floor area',
            value: floor_area? `${floor_area} sq. ft.`: floor_area
          },
          {
            label: 'Floor Area of Seated',
            value: floor_area_of_seated? `${floor_area_of_seated} sq. ft.`: floor_area_of_seated
          },
          {
            label: 'Floor Area of Workspace',
            value: floor_area_of_workspace? `${floor_area_of_workspace} sq. ft.`: floor_area_of_workspace
          },
          {
            label: 'Any mezzanine/terrace/extended building structure involved? ',
            value: this.getOptionName('yesNoOptions', building_structure_ind)
          },
          {
            label: 'Any designer decoration? Plate glass?',
            value: this.getOptionName('yesNoOptions', designer_ind)
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'What kind of stock?',
            value: kind_of_stock,
            isHide: !contents_ind
          },
          {
            label: 'Total stocks value',
            value: total_stocks? `HK$ ${total_stocks}`: total_stocks ,
            isHide: !contents_ind
          },
          {
            label: 'Any wine or high-value stock (e.g. dried seafood, abalone)? ',
            value: this.getOptionName('yesNoOptions', high_stock_ind),
            isHide: !contents_ind
          },
          {
            label: 'Max. value per piece of wine or high-value stock?',
            value: high_stock_value? `HK$ ${high_stock_value}`: high_stock_value,
            isHide: high_stock_ind != 1 || !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Cook with fire or Non-fire cooking?',
            value: this.getOptionName('globalOptions.cook_with_fire', cook_with_fire),
            isHide: !public_liability_ind
          },
          {
            label: 'Any fire sprinkler or extinguisher system',
            value: this.getOptionName('yesNoOptions', fire_system_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'Any Burglar alarm or Security system',
            value: this.getOptionName('yesNoOptions', burglar_system_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'Any neon signboard outside premises? Hang-up/ placing outside the shop?',
            value: this.getOptionName('yesNoOptions', signboard_outside_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'What\'s the height from ground level?',
            value: high_from_ground_level,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'What\'s the size of the signboard?',
            value: size_of_signboard,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2101) {
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Floor area',
            value: floor_area? `${floor_area} sq. ft.`: floor_area
          },
          {
            label: 'Any fire alarm installed?',
            value: this.getOptionName('yesNoOptions', fire_alarm_ind)
          },
          {
            label: 'Any burglar alarm system installed?',
            value: this.getOptionName('yesNoOptions', burglar_alarm_ind)
          },
          {
            label: 'Co-work space?',
            value: this.getOptionName('yesNoOptions', work_space_ind)
          },
          {
            label: 'How is the Insured premises been separated?',
            value: this.getOptionName('globalOptions.insured_premises', insured_premises),
            isHide: work_space_ind != 1
          },
          {
            label: 'Any stocks stored within premises?',
            value: this.getOptionName('yesNoOptions', stocks_stored_ind)
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any Manual Work ?',
            value: this.getOptionName('yesNoOptions', manual_work_ind),
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2201) {
        // retail
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Business hour',
            value: business_hour
          },
          {
            label: 'Any plate glass in the premises?',
            value: this.getOptionName('yesNoOptions', glass_premises_ind)
          },
          {
            label: 'What is the value of plate glass?',
            value: value_of_glass,
            isHide: glass_premises_ind != 1
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'What kind of stock?',
            value: kind_of_stock,
            isHide: !contents_ind
          },
          {
            label: 'Stocks value',
            value: total_stocks? `HK$ ${total_stocks}`: total_stocks,
            isHide: !contents_ind
          },
          {
            label: 'Is stock stored in locked room?',
            value: this.getOptionName('yesNoOptions', stock_stored_locked_ind),
            isHide: !contents_ind
          },
          {
            label: 'Max. value per piece/carton of stock?',
            value: value_stock_stored_locked? `HK$ ${value_stock_stored_locked}`: value_stock_stored_locked,
            isHide: !contents_ind
          },
          {
            label: 'Any Burglar alarm or Security system',
            value: this.getOptionName('yesNoOptions', burglar_system_ind),
            isHide: !contents_ind
          },
          {
            label: 'Any fire sprinkler or extinguisher system',
            value: this.getOptionName('yesNoOptions', fire_system_ind),
            isHide: !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Any neon signboard outside premises? Hang-up/ placing outside the shop?',
            value: this.getOptionName('yesNoOptions', signboard_outside_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'What\'s the height from ground level?',
            value: high_from_ground_level,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'What\’s the size of the signboard?',
            value: size_of_signboard,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any Manual Work ?',
            value: this.getOptionName('yesNoOptions', manual_work_ind),
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2301) {
        // beauty
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Business hour',
            value: business_hour
          },
          {
            label: 'Floor area',
            value: floor_area? `${floor_area} sq. ft.`: floor_area
          },
          {
            label: 'No. of treatment rooms',
            value: no_of_rooms
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'Stocks value',
            value: total_stocks? `HK$ ${total_stocks}`: total_stocks,
            isHide: !contents_ind
          },
          {
            label: 'Value of the beauty devices (preferably to have the list of machines, otherwise, average and max value of the devices)',
            value: value_of_beauty_devices,
            isHide: !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Any neon signboard outside premises? Hang-up/ placing outside the shop?',
            value: this.getOptionName('yesNoOptions', signboard_outside_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'What\'s the height from ground level?',
            value: high_from_ground_level,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'What\’s the size of the signboard?',
            value: size_of_signboard,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2401) {
        // education
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Business hour',
            value: business_hour
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Types of courses',
            value: this.getOptionName('globalOptions.typ_of_courses', typ_of_courses),
            isHide: !public_liability_ind
          },
          {
            label: 'Target customers group',
            value: this.getOptionName('globalOptions.target_customers_group', target_customers_group),
            isHide: !public_liability_ind
          },
          {
            label: 'Regular classes or Ad hoc classes?',
            value: this.getOptionName('globalOptions.regular_classes', regular_classes),
            isHide: !public_liability_ind
          },
          {
            label: 'Number of participants per class?',
            value: no_of_people,
            isHide: !public_liability_ind
          },
          {
            label: 'Outdoor/ indoor/ online class?',
            value: this.getOptionName('globalOptions.class_type', class_type),
            isHide: !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2501) {
        // hair
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'Value of the beauty devices (preferably to have the list of machines, otherwise, average and max value of the devices)',
            value: value_of_beauty_devices,
            isHide: !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Any neon signboard outside premises? Hang-up/ placing outside the shop?',
            value: this.getOptionName('yesNoOptions', signboard_outside_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'What\'s the height from ground level?',
            value: high_from_ground_level,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'What\’s the size of the signboard?',
            value: size_of_signboard,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }
      else if(this.type == 2601) {
        // warehouse
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Building Type?',
            value: this.getOptionName('globalOptions.building_type', building_type)
          },
          {
            label: 'Premises occupied by Insured only / shared with others?',
            value: this.getOptionName('globalOptions.warehouse_type', warehouse_type)
          },
          {
            label: 'How is the space being shared/divided? ',
            value: this.getOptionName('globalOptions.space_divided_type', space_divided_type),
            isHide: warehouse_type != 2
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Group Medical Insurance',
                value: !!need_group_medical_ind
              },
              {
                label: 'Group Travel',
                value: !!need_group_travel_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
              {
                label: 'Marine Cargo Insurance',
                value: !!need_marine_ind
              }
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'What kind of stock?',
            value: kind_of_stock,
            isHide: !contents_ind
          },
          {
            label: 'Total stocks value',
            value: total_stocks? `HK$ ${total_stocks}`: total_stocks,
            isHide: !contents_ind
          },
          {
            label: 'What’s the maximum value per piece/carton?',
            value: max_piece_carton_value? `HK$ ${max_piece_carton_value}`: max_piece_carton_value,
            isHide: !contents_ind
          },
          {
            label: 'Average value of stocks per period?',
            value: avg_stocks_value? `HK$ ${avg_stocks_value}`: avg_stocks_value,
            isHide: !contents_ind
          },
          {
            label: 'Maximum value of stocks per period?',
            value: max_stocks_value? `HK$ ${max_stocks_value}`: max_stocks_value,
            isHide: !contents_ind
          },
          {
            label: 'How the stocks are stored?',
            value: this.getOptionName('globalOptions.stocks_stored_type', stocks_stored_type),
            isHide: !contents_ind
          },
          {
            label: 'Any Burglar alarm or Security system',
            value: this.getOptionName('yesNoOptions', burglar_system_ind),
            isHide: !contents_ind
          },
          {
            label: 'Any Fire extinguisher?',
            value: this.getOptionName('yesNoOptions', fire_system_ind),
            isHide: !contents_ind
          },
          {
            label: 'Any windows? Only one entrance/exit?',
            value: this.getOptionName('globalOptions.entrance_exit', entrance_exit),
            isHide: !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          },
        ]
      }
      else if(this.type == 2701) {
        // medical
        result = [
          {
            label: 'Insured Name',
            value: isrd_nm
          },
          {
            label: 'Floor area',
            value: floor_area? `${floor_area} sq. ft.`: floor_area
          },
          {
            label: 'Any burglar alarm system installed?',
            value: this.getOptionName('yesNoOptions', burglar_system_ind)
          },
          {
            label: 'Any specific/ high-valued machines/devices that needs to be insured?',
            value: this.getOptionName('yesNoOptions', devices_insured_ind)
          },
          {
            label: 'List of Insured Machinery',
            value: insured_machinery
          },
          {
            label: 'If not a clinic ……. Apart from doctor consultation, any other services will be provided? (e.g. physiotherapy, dental, X-ray)',
            value: other_service_provided
          },
          {
            label: 'Any claim history in the past 3 years?',
            value: this.getOptionName('yesNoOptions', claim_history_ind)
          },
          {
            label: 'Business Registration Certificate',
            value: business_file? business_file.client_name: '-',
            haveFile: !!business_file.client_name,
            isFile: true
          },
          {
            label: 'Other insurance you may need',
            value: [
              {
                label: 'Group Personal Accident Insurance',
                value: !!need_group_personal_ind
              },
              {
                label: 'Money Insurance',
                value: !!need_money_ind
              },
              {
                label: 'Fidelity Guarantee Insurance',
                value: !!need_fidelity_ind
              },
            ],
            isArray: true
          },
          {
            label: 'Contents',
            value: contents_ind? '√': '×'
          },
          {
            label: 'What kind of stock?',
            value: kind_of_stock,
            isHide: !contents_ind
          },
          {
            label: 'Stocks value',
            value: total_stocks? `HK$ ${total_stocks}`: total_stocks,
            isHide: !contents_ind
          },
          {
            label: 'Public Liability',
            value: public_liability_ind? '√': '×'
          },
          {
            label: 'Any neon signboard outside premises? Hang-up/ placing outside the shop?',
            value: this.getOptionName('yesNoOptions', signboard_outside_ind),
            isHide: !public_liability_ind
          },
          {
            label: 'What\'s the height from ground level?',
            value: high_from_ground_level,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'What\’s the size?',
            value: size_of_signboard,
            isHide: signboard_outside_ind != 1 || !public_liability_ind
          },
          {
            label: 'Employee’s Compensation',
            value: employee_ind? '√': '×'
          },
          {
            label: 'Total Number of Employee(s)',
            value: total_no_of_employee,
            isHide: !employee_ind
          },
          {
            label: 'Any staff needs to station overseas (include staying in China or Macau)? ',
            value: this.getOptionName('yesNoOptions', station_overseas_ind),
            isHide: !employee_ind
          }
        ]
      }

      if(employee_ind) {
        // occ list
        let occItem
        occ_information_list.some((item, index) => {
          occItem = [
            {
              label: `Occupation ${index+1}`,
              value: ''
            },
            {
              label: 'Occupation / Position',
              value: item.occ_position
            },
            {
              label: 'Number of Employee(s)',
              value: item.no_of_employee
            },
            {
              label: 'Estimate Annual Salary?',
              value: item.annual_salary? `HK$ ${item.annual_salary}`: item.annual_salary
            },
            {
              label: 'Nature',
              value: this.getOptionName('globalOptions.nature', item.nature)
            },
          ]
          result = [
            ...result,
            ...occItem
          ]
        })
      }




      this.list = result
    },
  }
}
</script>
